/**
 * Generates FAQPage structured data (JSON-LD) from FAQ items.
 * @param {Array} items - Array of FAQ items with question and answer
 * @returns {Object|null} - FAQPage schema.org structured data or null if no valid items
 */
export const generateFaqStructuredData = items => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return null;
  }

  const mainEntity = items.reduce((faqItems, item) => {
    if (item?.question?.text && item?.answer?.html) {
      faqItems.push({
        '@type': 'Question',
        name: item.question.text,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer.html,
        },
      });
    }
    return faqItems;
  }, []);

  if (mainEntity.length === 0) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };
};

export default {
  generateFaqStructuredData,
};
